// extracted by mini-css-extract-plugin
export var navLink = "gZ_pK";
export var navMenuPrimary = "gZ_pJ";